"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var Count = /** @class */ (function (_super) {
    tslib_1.__extends(Count, _super);
    function Count() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Count.prototype.render = function () {
        if (lodash_1.isNil(this.props.count)) {
            return null;
        }
        return (React.createElement("div", { className: "facet__option__count" },
            "(",
            I18n.toNumber(this.props.count, { precision: 0 }),
            ")"));
    };
    return Count;
}(React.Component));
exports.default = Count;
//# sourceMappingURL=count.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/count.js
// module id = NmcX
// module chunks = 0 1 2 20